import { Action } from '../../actions';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import LocalStorageManager from '../../utils/localStorage/manager';
import UserAgentUtils from '../../utils/userAgent';
import ApiUtils from '../../utils/api';
import { Api } from '../../typings/api';
import { createNotification } from '../NotificationBar/actions';
import { PendingTasksManagerState } from './reducer';

enum PendingTasksManagerActionKeys {
	INIT_PENDING_TASKS = '@@offlineManager/INIT_PENDING_TASKS',
	ADD_PENDING_SHARE = '@@offlineManager/ADD_PENDING_SHARE',
	CLEAR_PENDING_SHARES = '@@offlineManager/CLEAR_PENDING_SHARES',
}

interface InitPendingTasksAction extends Action {
	type: PendingTasksManagerActionKeys.INIT_PENDING_TASKS;
	pendingTasks: PendingTasksManagerState;
}

interface ClearPendingSharesAction extends Action {
	type: PendingTasksManagerActionKeys.CLEAR_PENDING_SHARES;
}

interface AddPendingShareAction extends Action {
	type: PendingTasksManagerActionKeys.ADD_PENDING_SHARE;
	pendingShare: Api.SharedData;
}

type PendingTasksManagerAction = InitPendingTasksAction |
	ClearPendingSharesAction |
	AddPendingShareAction;

const loadPendingTasksManager = () => (dispatch: Dispatch<StoreState>, getState: () => StoreState): void => {
	const previousPendingTasks = LocalStorageManager.getPendingTasks();
	if (previousPendingTasks) {
		dispatch(initPendingTasks(previousPendingTasks));
	}

	dispatch(sendPendingShares());

	UserAgentUtils.subscribeToConnectionIsUp(() => {
		dispatch(sendPendingShares());
	});
};
const sendPendingShares = () => (dispatch: Dispatch<StoreState>, getState: () => StoreState): void => {
	const { pendingTasksManager } = getState();
	const { shares } = pendingTasksManager;

	if (UserAgentUtils.isOnline() && shares.length !== 0) {
		for (let i = 0; i < shares.length; i++) {
			const pendingShare = shares[i];

			ApiUtils.shareContent(pendingShare);
		}

		dispatch(clearPendingShares());

		dispatch(createNotification('info.selection_sent'));
	}
};

const initPendingTasks = (pendingTasks: PendingTasksManagerState) => (dispatch: Dispatch<StoreState>, getState: () => StoreState): void => {
	const action: InitPendingTasksAction = {
		type: PendingTasksManagerActionKeys.INIT_PENDING_TASKS,
		pendingTasks: pendingTasks,
	};
	dispatch(action);
};

const clearPendingShares = () => (dispatch: Dispatch<StoreState>, getState: () => StoreState): void => {
	const action: ClearPendingSharesAction = {
		type: PendingTasksManagerActionKeys.CLEAR_PENDING_SHARES,
	};
	dispatch(action);
};

const addPendingShare = (pendingShare: Api.SharedData) => (dispatch: Dispatch<StoreState>, getState: () => StoreState): void => {
	const action: AddPendingShareAction = {
		type: PendingTasksManagerActionKeys.ADD_PENDING_SHARE,
		pendingShare: pendingShare,
	};
	dispatch(action);
};

export { PendingTasksManagerActionKeys, PendingTasksManagerAction, loadPendingTasksManager, addPendingShare };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/PendingTasksManager/actions.ts